var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.09,6.06L23.94.91c-.58-.58-1.37-.91-2.19-.91H3.09C1.39,0,0,1.39,0,3.09v23.81c0,1.71,1.39,3.09,3.09,3.09h23.81c1.71,0,3.09-1.39,3.09-3.09V8.25c0-.82-.33-1.61-.91-2.19Zm-11.12-2.96v2.98h-5.95v-2.98h5.95Zm-8.93,23.81v-8.93h11.91v8.93h-11.91Zm17.86,0h-2.86v-8.93c0-1.71-1.39-3.09-3.09-3.09h-11.91c-1.71,0-3.09,1.39-3.09,3.09v8.93h-2.86V3.09h5.84v2.98c0,1.71,1.39,3.09,3.09,3.09h5.95c1.71,0,3.09-1.39,3.09-3.09v-2.98h.68l5.15,5.15v18.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/saveIcon.6b67d590e0bf92c157b3a623fbb9f16f.svg";
export { ForwardRef as ReactComponent };